import { createSlice } from "@reduxjs/toolkit";
import { getDateFilterRanges , dateFilterTypes } from "./loadsDashboardConsts";

export const loadsDashboardSlice = createSlice({
    name: 'loadsDashboardSlice',
    initialState: {
        dashboardFilters: {
            pickupLocationId: { value: null },
            deliveryLocationId: { value: null },
            carrierId: { value: null },
            clientId: { value: null },
            clientAccountId: { value: null },
            loadDistance: { value: null },
            moveType: { value: null },
            dateFilterType: { value: dateFilterTypes.QUARTER },
            dateFilter: { value: 1 },
            startDate: { value: getDateFilterRanges()?.[dateFilterTypes.QUARTER]?.[0]?.startDate.toDateString() }, // First day of the month
            endDate: { value: getDateFilterRanges()?.[dateFilterTypes.QUARTER]?.[0]?.endDate.toDateString() }, // First day of the month
        }
    },
    reducers: {
        setFilters: (state, action) => {
            state.dashboardFilters = action.payload;
        },
    },
});

export const { setFilters } = loadsDashboardSlice.actions;
